import { render, staticRenderFns } from "./LmProcessNewOrEdit.vue?vue&type=template&id=5c7d812d&scoped=true&"
import script from "./LmProcessNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./LmProcessNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./LmProcessNewOrEdit.vue?vue&type=style&index=0&id=5c7d812d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7d812d",
  null
  
)

export default component.exports